import { Col, Row, Container } from "react-bootstrap";
import { useLandingConfig } from "../../context/OpenDoorEventContext";
import useInscripcionSubmit from "./useInscripcionSubmit";
import FormularioRanger from "./FormularioRanger";
import FormularioEstados from "./FormularioEstados";
import "./Formulario.scss";

const Formulario = () => {
  const config = useLandingConfig();
  const { loading, status, setStatus, submitInscripcion } = useInscripcionSubmit(config);

  const mostrarFormulario = status === null;

  return (
    <Container className="pb-5 formulario-montserrat formulario-ranger-wrap" id="formulario-inscripcion">
      <Row>
        <Col lg={10} xl={9} xs={12} className="mx-auto">
          <div className="formulario-ranger-card">
            {mostrarFormulario && (
              <FormularioRanger loading={loading} onSubmit={submitInscripcion} config={config} />
            )}
            <FormularioEstados status={status} onRetry={() => setStatus(null)} />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Formulario;
